import { appServices } from '../helpers/app-services/AppServices';

class ScribeProvider {
  getScribes = queryParams => {
    return appServices.projects.getProjectList(queryParams);
  };

  deleteScribe = scribe => {
    return appServices.projects.deleteProject(scribe);
  };
}

export default ScribeProvider;
